export function getBaseUtcOffset(): number {
  const year = new Date().getFullYear();

  // getTimezoneOffset is larger during standard time in both hemispheres.
  return Math.max(
    new Date(year, 0, 1).getTimezoneOffset(),
    new Date(year, 6, 1).getTimezoneOffset(),
  );
}
